module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// ../path-to-regexp/node_modules/isarray/index.js
// module id = 413
// module chunks = 0